import { getIsBeelineError } from "../../../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/dependencies/getIsBeelineError/dev";
import { getContent } from "../../../../../../../dependencies/getContent/dev";
import { getIsMobile } from "../../../../../../../dependencies/getIsMobile/dev";
import { getUserAccountInfo } from "../../../../../../../dependencies/getUserAccountInfo/dev";
import { submitPayment } from "../../../../../../../dependencies/submitPayment/dev.resend";
import { getMapStateToSmsCodeExpiredRequestStatusProps } from "./logic";

/**
 * Set up dependencies for the payment error popup state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToSmsCodeExpiredRequestStatusProps = getMapStateToSmsCodeExpiredRequestStatusProps({
  getContent: getContent,
  getIsBeelineError: getIsBeelineError,
  submitPayment: submitPayment,
  getIsMobile: getIsMobile,
  getUserAccountInfo: getUserAccountInfo
});